import { render } from "./AddAnswerModal.vue?vue&type=template&id=5ecaa791"
import script from "./AddAnswerModal.vue?vue&type=script&lang=js"
export * from "./AddAnswerModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__